import {Shop} from "@/entities/shop";
import styles from "./ShopCard.module.scss";

type Props = {
    phone?: Shop["phone"];
    itemProp?: string;
};

const normalizePhone = (phone: string) => {
    return phone.replace(/\D/g, "");
};

export const ShopPhone = ({phone = "", itemProp}: Props) => {
    if (!phone) {
        return null;
    }

    const phones = phone
        .split("|")
        .map(value => value.trim())
        .filter(Boolean);

    return (
        <div className={styles.phones}>
            {phones.map((phone, index) => {
                const isLast = index === phones.length - 1;

                return (
                    <a
                        key={`${phone}-${index}`}
                        href={`tel:+${normalizePhone(phone)}`}
                        className={styles.phone}
                        itemProp={itemProp}
                    >
                        {phone}{!isLast && ", "}
                    </a>
                );
            })}
        </div>
    );
};
